$(document).ready(function() {
    runEvery500ms();
});

function checkCondition() {
    let dataCode = $('.transcy-popup-languages button.transcy-switcher-content__item-selected').attr('data-code');
    return dataCode !== undefined;
}

function runEvery500ms() {
    let interval = setInterval(function() {
        if (checkCondition()) {
            clearInterval(interval);

            let active_lang = $('.transcy-popup-languages button.transcy-switcher-content__item-selected').attr('data-code');
            let active_cur = $('.transcy-popup-currencies button.transcy-switcher-content__item-selected').attr('data-code');

            //set active on selector
            let count = $(`#language .language-item[data-language="${active_lang}"][data-currency="${active_cur}"]`).length;
            if (count == 1) {
                $(`#language .language-item[data-language="${active_lang}"][data-currency="${active_cur}"]`).addClass('active');
            }
            else if (count > 1) {
                if ($.cookie('selected-language') !== undefined) {
                    let selected = $.cookie('selected-language');
                    $(`#language .language-item[data-name="${selected}"]`).addClass('active');
                } else {
                    $(`#language .language-item[data-language="${active_lang}"]`).first().addClass('active');
                }
            }

            $('#header .nav-language span').html(active_lang.substr(0, 2).toUpperCase());
        }
    }, 500);
}

$('#language .language-item').on('click', function() {
    let name = $(this).attr('data-name');
    $.cookie('selected-language', name, { expires: 1 });

    //select language
    let language = $(this).attr('data-language').trim();
    $(`.transcy-popup-languages button[data-code="${language}"]`).trigger('click');
    
    //select currency
    let currency = $(this).attr('data-currency').trim();
    $(`.transcy-popup-currencies button[data-code="${currency}"]`).trigger('click');

    $('.transcy-btn-apply button').trigger('click');
});

$('.nav-language').on('click', function() {
    $('#language').css('display', 'flex');
    $('body').css('overflow-y', 'hidden');
});

$('.language-close').on('click', function() {
    $('#language').css('display', 'none');
    $('body').css('overflow-y', 'visible');
});